import React, { useEffect, useState } from "react";

import { Link, useNavigate } from "react-router-dom/dist";
import Table from "../../../../../core/pagination/datatable";
import CommonFooter from "../../../../../core/common/footer/commonFooter";
import { Edit, RotateCcw } from "feather-icons-react/build/IconComponents";
import Swal from "sweetalert2";
import AddLeaveType from "./Add";
import EditLeaveType from "./Edit";
import { ROLL_CALL_API_BASE_URL } from "../../RollCallConfig/RollCallConfig";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";
import { Spin, Switch } from "antd";

const RollcallLeaveTypes = () => {
  const [editObj, setEditObj] = useState([]);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [tokenData, setTokenData] = useState(null);
  const [superIdData, setSuperIdData] = useState(null);
  const [perm, setPerm] = useState({
    Read: false,
    Write: false,
    Delete: false,
    Export: false,
  });

  useEffect(() => {
    const raw = sessionStorage.getItem("rollcall-permissions");
    if (!raw) return;

    const permissions = JSON.parse(raw);

    // current route → "/rollcall/registrations"
    const currentRoute = window.location.pathname.replace("/", "");
    const pagePerm = permissions.find((p) => p.path === currentRoute);
    if (pagePerm) {
      setPerm({
        Read: pagePerm.Read,
        Write: pagePerm.Write,
        Delete: pagePerm.Delete,
        Export: pagePerm.Export,
      });
    }
  }, []);

  const navigate = useNavigate();
  console.log(perm, "permmmmmmmmmmm");

  useEffect(() => {
    const token = sessionStorage.getItem("authToken");
    const superId = sessionStorage.getItem("superId");

    if (token && superId) {
      setTokenData(token);
      setSuperIdData(superId);
    } else {
      console.warn("User data not found in sessionStorage");
      navigate("/signin");
    }
  }, [navigate]);

  useEffect(() => {
    if (tokenData && superIdData) {
      console.log("Token:", tokenData);
      console.log("SuperId:", superIdData);
    }
  }, [tokenData, superIdData]);

  const handleReload = () => {
    window.location.reload();
  };

  const fetchLeaveTypes = async () => {
    setLoading(true);
    if (tokenData && superIdData) {
      try {
        const response = await fetch(
          `${ROLL_CALL_API_BASE_URL}portal/leave/getleavetype`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${tokenData}`,
            },
          }
        );

        if (!response.ok) throw new Error("Failed to fetch leave types");

        const data = await response.json();
        if (data.status) setLeaveTypes(data.ResultData || []);
        else
          Swal.fire({
            title: "Error",
            text: data.ErrorMsg || "Unable to fetch leave types",
            icon: "error",
          });
      } catch (error) {
        console.error("Error fetching leave types:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    if (tokenData && superIdData) {
      fetchLeaveTypes();
    }
  }, [tokenData, superIdData]);

  const filteredData = (leaveTypes || [])
    .slice()
    .sort((a, b) => b.IsActive - a.IsActive)
    .filter(
      (item) =>
        (item.LvType && item.LvType.toLowerCase()) ||
        (item.LvCode && item.LvCode.toLowerCase())
    );

  console.log(filteredData);

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      sorter: (a, b) => a.id - b.id,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Name",
      dataIndex: "LvType",
      sorter: (a, b) => a.LvType.length - b.LvType.length,
    },
    {
      title: "Abbreviation",
      dataIndex: "LvCode",
      sorter: (a, b) => a.LvCode.length - b.LvCode.length,
    },
  ];

  if (perm?.Delete) {
    columns.push({
      title: "Status",
      dataIndex: "IsActive",
      sorter: (a, b) => a.IsActive - b.IsActive,
      key: "status",
      render: (isActive, record) => (
        <Switch
          checked={isActive}
          style={{
            transform: "scale(0.8)",
            transformOrigin: "left center",
          }}
          onChange={() => {
            handleDeleteConfirmation(record.Id);
          }}
        />
      ),
    });
  }
  if (perm?.Write) {
    columns.push({
      title: "Action",
      dataIndex: "action",
      align: "center",
      render: (__, record) => (
        <div className="action-table-data d-flex justify-content-center">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              onClick={() => setEditObj(record)}
              data-bs-toggle="offcanvas"
              data-bs-target="#offcanvasRightEditLeaveType"
              aria-controls="offcanvasRightEditLeaveType"
            >
              <Edit className="feather-edit text-info" />
            </Link>
          </div>
        </div>
      ),
    });
  }
  const handleDeleteConfirmation = (Id) => {
    if (tokenData) {
      Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Action it!",
        cancelButtonText: "No, cancel",
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            const response = await fetch(
              `${ROLL_CALL_API_BASE_URL}portal/leave/deleteLeaveTypes`,
              {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                  Authorization: `Bearer ${tokenData}`,
                },
                body: JSON.stringify({ id: Id }),
              }
            );

            const responseData = await response.json();
            console.log(responseData);

            if (responseData.status) {
              Swal.fire("Action Sucessfull .", "success").then(() => {
                fetchLeaveTypes();
              });
            } else {
              Swal.fire("Error", "Failed to delete the holiday.", "error");
            }
          } catch (error) {
            console.error("Error deleting holiday:", error);
            Swal.fire("Error", "Failed to delete the holiday.", "error");
          }
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire("Cancelled", "Your item is safe :)", "info");
        }
      });
    }
  };

  const handleDownloadExcel = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const wb = XLSX.utils.book_new();
    const wsData = filteredData.map((item, index) => ({
      "S.No": index + 1,
      "Leave Type": item.LvType || "N/A",
      "Leave Code": item.LvCode || "N/A",
      IsActive: item.IsActive || "N/A",
    }));

    const ws = XLSX.utils.json_to_sheet(wsData);
    XLSX.utils.book_append_sheet(wb, ws, "Leave Data");
    XLSX.writeFile(wb, "LeaveType_Data.xlsx");
  };

  const generatePDF = () => {
    if (filteredData && filteredData.length === 0) {
      return;
    }

    const doc = new jsPDF();
    doc.text("Leave Report", 14, 10);

    const tableColumn = ["S.No", "LeaveType", "LeaveCode", "IsActive"];
    const tableRows = filteredData.map((item, index) => [
      index + 1,
      item.LvType || "N/A",
      item.LvCode || "N/A",
      item.IsActive || "N/A",
    ]);

    doc.autoTable({ head: [tableColumn], body: tableRows });
    doc.save("LeaveType_Data.pdf");
  };

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  return (
    <div>
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/rollcall/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Leave Types
                    </h4>
                  </ol>
                </nav>
                <h6>Manage Leave Types</h6>
              </div>
            </div>
            <ul className="table-top-head">
              {perm?.Export && (
                <>
                  <li>
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <Link onClick={generatePDF}>
                        <ImageWithBasePath
                          src="assets/img/icons/pdf.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                  <li>
                    <OverlayTrigger
                      placement="top"
                      overlay={renderExcelTooltip}
                    >
                      <Link
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        onClick={handleDownloadExcel}
                      >
                        <ImageWithBasePath
                          src="assets/img/icons/excel.svg"
                          alt="img"
                        />
                      </Link>
                    </OverlayTrigger>
                  </li>
                </>
              )}
              <li onClick={handleReload}>
                <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                  <Link data-bs-toggle="tooltip" data-bs-placement="top">
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
            {perm?.Write && (
              <div className="page-btn mb-3">
                <Link
                  to="#"
                  className="btn btn-success btn-sm"
                  data-bs-toggle="offcanvas"
                  data-bs-target="#offcanvasRightAddLeaveType"
                  aria-controls="offcanvasRightAddLeaveType"
                >
                  <i className="ti ti-circle-plus fs-4"></i>
                </Link>
              </div>
            )}
          </div>
          {/* /product list */}
          <div className="card table-list-card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="search-set"></div>
              <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <div className="col-6 mb-2">
                  <label className="form-label"></label>
                </div>
              </div>
            </div>
            <div className="card-body">
              <div className="table-responsive brand-table">
                {loading ? (
                  <div className="text-center my-4">
                    <Spin size="large" />
                    <p>Loading data...</p>
                  </div>
                ) : (
                  <div className="table-responsive brand-table">
                    <Table columns={columns} dataSource={filteredData} />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>

      <AddLeaveType />
      <EditLeaveType editObj={editObj} />
    </div>
  );
};

export default RollcallLeaveTypes;
